import React from 'react';
import { Link } from 'react-router-dom';
import s from './footerMenuList.module.css';

// import s from './MenuList.module.css'

const MenuList = ({ menu, title }) => {
  return (
    <div>
      <h3 className={s.title}>{title}</h3>
      <ul>
        {menu.map(({ id, title, path }) => (
          <li className={s.item} key={id}>
            <Link className={s.link} to={`/${path}`}>
              {title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MenuList;
